<template>
    <div class="o-box-content">
        <div class="o-box__subtitle o-subtitle c-find-assureur__title" v-html="t('Contactez directement <br>votre assureur')"></div>

        <div class="c-find-assureur">
            <!-- <div class="c-find-assureur__input">
                <svg class="o-ico c-find-assureur__ico -left" aria-hidden="true" role="img">
                    <use xlink:href="/assets/img/sprite.svg#search"></use>
                </svg>
                <input type="text" class="o-input c-find-assureur__input" placeholder="Chercher un assureur">
                <svg class="o-ico c-find-assureur__ico -right" aria-hidden="true" role="img">
					<use xlink:href="/assets/img/sprite.svg#arrow-down-alt"></use>
			    </svg>
            </div> -->
            <v-select class="c-find-assureur__input" v-model="selectedAssureur" :options="assureursOptions" placeholder="Trouver mon assureur...">
                <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                        {{ t('Aucun résultat pour') }} <strong>{{ search }}</strong>
                    </template>
                </template>
            </v-select>

            <template v-if="selectedAssureur">
                <div v-if="selectedAssureur.assureur.tel" class="c-find-assureur__content">
                    <div class="c-find-assureur__row">
                        <div class="c-find-assureur__label">
                            {{ t('Sans-frais') }}
                        </div>
                        <div class="c-find-assureur__value">
                            <a :href="selectedAssureur.assureur.tel">{{ formatPhone(selectedAssureur.assureur.tel) }}</a>
                        </div>
                    </div>
                </div>
                <div v-if="selectedAssureur.assureur.url" class="c-find-assureur__button">
                    <a :href="selectedAssureur.assureur.url" class="o-button -button-block-center -button-text -button-black" target="_blank" rel="">
                        <span class="o-button__text">
                            <span class="o-button__text__elm">
                                {{ t('Accéder au site Web') }}
                            </span>
                        </span>
                    </a>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: 'Assureurs',
    components: {
        vSelect
    },
    data() {
        return {
            assureurs: window.assureurs,
            selectedAssureur: null
        }
    },
    computed: {
        assureursOptions() {
            return this.assureurs.map(assureur => {
                return {
                    label: assureur.nom,
                    assureur: assureur
                }
            })
        }
    },
    methods: {
        formatPhone(phone) {
            // remove tel: prefix and format phone number
            return phone.replace('tel:', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
        },
        t(string) {
            return window.assureurTraductions[string] || string
        }
    }
}
</script>